import React from 'react'
import {connect} from 'react-redux'

import showModal from '../shared/data/actions/show_modal'

class ConversationMenuSubscribeItem extends React.Component {
  constructor (props) {
    super(props)

    this.openSubscriptionModal = this.openSubscriptionModal.bind(this)
  }

  openSubscriptionModal (e) {
    if (e && e.preventDefault) e.preventDefault()
    if (e && e.stopPropagation) e.stopPropagation()

    this.props.showModal({type: 'groupSubscribe', props: {groupId: this.props.groupId}})
  }

  render () {
    if (!this.props.currentUserUid) return false
    if (!this.props.groupId) return false

    return (
      <div className='sliding-menu-item subscribe-group' onClick={this.openSubscriptionModal}>
        <i className='menu-item-icon rc-icon-subscribe'></i>
        {this.props.subscribedGroup ? 'Change notifications' : 'Notifications'}
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const currentUserUid = state.getIn(['currentUser', 'uid'])
  const subscribedGroup =  state.getIn(['groups', '_subscriptions', 'users', currentUserUid, ownProps.groupId])

  return {currentUserUid, subscribedGroup}
}

const mapDispatchToProps = (dispatch) => {
  return {
    showModal: (modal) => dispatch(showModal(modal))
  }
}

const ConversationMenuSubscribeItemContainer = connect(
  mapStateToProps, mapDispatchToProps
)(ConversationMenuSubscribeItem)

export default ConversationMenuSubscribeItemContainer



/** WEBPACK FOOTER **
 ** ./modules/chat_ui/conversation_menu_subscribe_item.js
 **/